export const MainArrow = () => {
    return <>
      <svg xmlns="http://www.w3.org/2000/svg" width="95" height="45" fill="none">
    <circle cx="14.539" cy="23.166" r="3.278" fill="#F9F9F9" transform="rotate(.14 14.54 23.166)" />
    <circle cx="25.793" cy="23.189" r="3.278" fill="#F9F9F9" transform="rotate(.14 25.793 23.19)" />
    <circle cx="3.285" cy="23.143" r="3.278" fill="#F9F9F9" transform="rotate(.14 3.285 23.143)" />
    <path fill="#F9F9F9" d="M37.078 19.166a3.5 3.5 0 1 0 0 7v-7Zm0 7h51.508v-7H37.078v7Z" />
    <path stroke="#F9F9F9" strokeLinecap="round" strokeWidth="7" d="M91.476 22.614C86.268 19.721 74.256 11.89 67.86 3.71M57.715 41.397c5.136-6.072 19.08-18.33 33.76-18.783" />
  </svg></>
}